import {
  FETCH_ASSET_GROUPS_REQUEST,
  FETCH_BUSINESS_FUNCTIONS_REQUEST,
} from "../types/business_functions";
import axiosInstance from "../../axios";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";
import { alertSuccess } from "../../utils/feedback";

export const fetchBusinessFunctions = (businessFunctions) => ({
  type: FETCH_BUSINESS_FUNCTIONS_REQUEST,
  payload: businessFunctions,
});

export const fetchAssetGroups = (assetGroups) => ({
  type: FETCH_ASSET_GROUPS_REQUEST,
  payload: assetGroups,
});

export const getBusinessFunctions = (orgaId) => {
  return async (dispatch) => {
    dispatch(requestStarted("Fetching_business_functions"));
    try {
      const res = await axiosInstance.get(
        `/survey/critical_business_functions/${orgaId}`
      );
      const businessFunctions = res.data;
      console.log("Business Functions:", businessFunctions?.business_functions);
      dispatch(fetchBusinessFunctions(businessFunctions?.business_functions));
      dispatch(requestSucceeded());
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
      // Handle error if needed
    }
  };
};

export function assetGroupList(bfId, orgaId) {
  return async (dispatch) => {
    try {
      dispatch(requestStarted("Fetching_asset_groups"));
      const res = await axiosInstance.get(
        `/survey/fetch-asset-groups/${bfId}/${orgaId}`
      );
      const assetGroups = res.data;
      // console.log("Asset Groups:", assetGroups);
      dispatch(fetchAssetGroups(assetGroups));
      dispatch(requestSucceeded());
      return assetGroups;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
      // Handle error if needed
    }
  };
}

export function updateOrgaAssets(orgaId, data) {
  return async (dispatch) => {
    try {
      dispatch(requestStarted("Updating_business_functions"));
      const res = await axiosInstance.post(`/survey/business_function_ops`, {
        orga_id: Number(orgaId),
        ops: data,
      });
      const updatedBusinessFunctions = res.data;
      dispatch(fetchBusinessFunctions(updatedBusinessFunctions));
      dispatch(requestSucceeded());
      alertSuccess(res.data);
      return updatedBusinessFunctions;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
      // Handle error if needed
    }
  };
}
